<template>
  <div class="w1200 dy">
    <div class="bg1" ref="setH">
      <!-- <div class="search1">
      <el-input v-model="input" placeholder="请输入关键字"></el-input>
      <el-button type="primary">查询</el-button>
      <el-button type="primary">导出</el-button>
      <el-button type="primary" class="fr">新增</el-button>
    </div> -->
      <div class="manageBox">
        <div class="searchBox" style="">
          <el-form ref="form" :model="search" label-width="120px" size="small">
            <el-form-item label="基础筛选：">
              <el-select v-model="search.sectionId" placeholder="选择学段" style="width: 100px" size="small" clearable>
                <el-option v-for="item in conditions.xueduanList" :key="item.node" :label="item.text" :value="item.node"></el-option>
              </el-select>
              <el-select v-model="search.gradeId" placeholder="选择年级" style="width: 100px" size="small" clearable>
                <el-option v-for="item in conditions.nianjiList" :key="item.node" :label="item.text" :value="item.node"></el-option>
              </el-select>
              <el-select v-model="search.subjectId" placeholder="选择学科" style="width: 100px" size="small" clearable>
                <el-option v-for="item in conditions.xuekeList" :key="item.node" :label="item.text" :value="item.node"></el-option>
              </el-select>
              <!-- 选择版本 -->
              <el-select v-model="search.versionId" placeholder="选择版本" style="width: 100px" size="small" clearable>
                <el-option v-for="item in conditions.banbenList" :key="item.node" :label="item.text" :value="item.node"></el-option>
              </el-select>
              <!-- 选择册次 -->
              <el-select v-model="search.volumeId" placeholder="选择册次" style="width: 100px" size="small" clearable>
                <el-option v-for="item in conditions.ceciList" :key="item.node" :label="item.text" :value="item.node"></el-option>
              </el-select>
              <!-- 选择章节1 -->
              <el-select v-model="search.firstChapterId" placeholder="选择章节" style="width: 100px" size="small" clearable @change="selChapter2">
                <el-option v-for="item in conditions.zhangjieList1" :key="item.node" :label="item.text" :value="item.node"></el-option>
              </el-select>
              <!-- 选择章节2 -->
              <el-select v-if="search.firstChapterId" v-model="search.secondChapterId" placeholder="选择章节" style="width: 100px" size="small" clearable
                         @change="selChapter3">
                <el-option v-for="item in conditions.zhangjieList2" :key="item.node" :label="item.text" :value="item.node"></el-option>
              </el-select>
              <!-- 选择章节3 -->
              <el-select v-if="search.secondChapterId" v-model="search.thirdChapterId" placeholder="选择章节" style="width: 100px" size="small" clearable
                         @change="selChapter4">
                <el-option v-for="item in conditions.zhangjieList3" :key="item.node" :label="item.text" :value="item.node"></el-option>
              </el-select>
              <!-- 选择章节4 -->
              <el-select v-if="search.thirdChapterId" v-model="search.fourthChapterId" placeholder="选择章节" style="width: 100px" size="small" clearable>
                <el-option v-for="item in conditions.zhangjieList4" :key="item.node" :label="item.text" :value="item.node"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="资源类别：">
              <el-radio-group v-model="search.resourceTypeId">
                <el-radio-button label="">全部</el-radio-button>
                <el-radio-button v-for="(resource, i) in conditions.ziyuanleibieList" :key="'resource' + i" :label="resource.code">{{ resource.name }}
                </el-radio-button>
              </el-radio-group>

              <!-- <el-select
                v-model="search.resourceTypeId"
                placeholder="资源类别"
                style="width: 100px"
                size="small"
                clearable
              >
                <el-option
                  v-for="item in conditions.ziyuanleibieList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                ></el-option>
              </el-select> -->
            </el-form-item>
            <el-form-item label="文档类型：">
              <el-radio-group v-model="search.fileType">
                <el-radio-button label="">全部</el-radio-button>
                <el-radio-button v-for="(resource, i) in conditions.wendangleixingList" :key="'resource' + i" :label="resource.key">{{ resource.value }}
                </el-radio-button>
              </el-radio-group>
            </el-form-item>
            <!-- <el-form-item label="纸张类型：">
              <el-radio-group v-model="search.paperType">
                <el-radio-button label="">全部</el-radio-button>
                <el-radio-button
                  v-for="(conditions, i) in conditions.paperTypeList"
                  :key="'conditions' + i"
                  :label="conditions.key"
                  >{{ conditions.value }}</el-radio-button
                >
              </el-radio-group>
            </el-form-item> -->
            <el-form-item label="资源名称：">
              <el-input v-model="search.resourceName" size="small" style="width: 150px; margin: 0 10px 0 0" placeholder="请输入内容"></el-input>
            </el-form-item>
            <el-form-item label="送印老师：">
              <el-input v-model="search.createUserName" size="small" style="width: 150px; margin: 0 10px 0 0" placeholder="请输入内容"></el-input>
            </el-form-item>
            <el-form-item label="打印状态：">
              <el-radio-group v-model="search.printState">
                <el-radio-button label="">全部</el-radio-button>
                <el-radio-button label="1">已打印</el-radio-button>
                <el-radio-button label="0">未打印</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="">
              <el-button type="primary" @click="getResourcesList" size="small">查询</el-button>
              <el-button type="primary" @click="daochu" size="small">导出</el-button>
            </el-form-item>
          </el-form>
        </div>

        <div class="contentBox">
          <div class="bd ys4" style="min-height: 520px">
            <ul v-if="tableData.length > 0">
              <li v-for="(d, i) in tableData" :key="i" style="height: auto; overflow: hidden">
                <div class="icon">
                  <svg class="icon" aria-hidden="true">
                    <use :xlink:href="'#icontbd' + d.fileType"></use>
                  </svg>
                  <em v-if="d.fileType == 1 || d.fileType == 2 || d.fileType == 3">- {{ d.filePage }}页 -</em>
                </div>
                <div class="title">
                  <h5 @click="yulan(d, 1)" style="cursor: pointer">
                    {{ d.resourceName }}
                  </h5>
                  <span class="catalog">
                    <i class="ka">{{ d.resourceTypeName }}</i>
                    <i v-if="d.versionName">{{ d.versionName }}</i>
                    <i v-if="d.volumeName">/{{ d.volumeName }}</i>
                    <i v-if="d.firstChapterName">/{{ d.firstChapterName }}</i>
                    <i v-if="d.secondChapterName">/{{ d.secondChapterName }}</i>
                    <i v-if="d.thirdChapterName">/{{ d.thirdChapterName }}</i>
                    <i v-if="d.fourthChapterName">/{{ d.fourthChapterName }}</i>
                  </span>
                  <span class="attribute">时间：{{ d.createTime.split(" ")[0] }}</span>
                  <span class="attribute">送印教师：{{ d.createUserName }}</span>
                  <span class="attribute">打印份数：{{ d.printNumber }}</span>
                  <span class="attribute">打印方式：{{ d.printTypeName }}</span>
                  <span class="attribute">纸张类型：{{ d.paperTypeName }}</span>
                  <span class="attribute">打印状态：<em :class="d.printStateName == '已打印' ? 'blue' : 'red'">{{ d.printStateName }}</em></span>
                  <span class="catalog" style="margin: 0"> 备注：{{ d.remark }} </span>
                  <!-- <span class="attribute">作者：{{ d.createUserName }}</span> -->
                </div>
                <div class="operate">
                  <el-button v-if="d.printState == 0" type="primary" @click="
                      finishData = d;
                      finish = true;
                    " size="small">打印完成</el-button>
                  <el-button v-else type="text" :disabled="true" size="small">--</el-button>
                  <el-button type="text" @click="beizhuShow(d)" size="small">备注</el-button>
                  <el-button type="text" @click="downloadFun(d)" size="small">下载</el-button>
                </div>
              </li>
            </ul>
            <div class="unusual" v-else>
              <span class="pt320">暂无内容</span>
            </div>
            <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange" background layout="total, sizes, prev, pager, next, jumper"
                           :total="pages.pageAll" :page-size="pages.pageSize"></el-pagination>
          </div>
        </div>
      </div>

      <el-dialog title="添加备注" :visible.sync="dialogVisible" width="30%">
        <el-input type="textarea" placeholder="请输入备注内容" :autosize="{ minRows: 4 }" v-model="beizhu.remark" maxlength="50" show-word-limit></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="baocunbeuzhu">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="完成打印" :visible.sync="finish" width="30%">
        <el-form ref="form" :model="finishData" label-width="90px" size="small">
          <el-form-item label="纸张数量：">
            <el-input v-model="finishData.filePageNum"></el-input>
          </el-form-item>
          <el-form-item label="纸张类型：">
            <el-radio-group v-model="finishData.paperType">
              <el-radio-button v-for="(conditions, i) in conditions.paperTypeList" :key="'conditions' + i" :label="conditions.key">{{ conditions.value }}
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="finish = false">取 消</el-button>
          <el-button size="small" type="primary" @click="dayinwancheng">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import fileDownload from "js-file-download";
import Axios from "axios";
import qs from "qs";
import downLoad from "../mixins/downLoad";
import yulan from "../mixins/yulan";
export default {
  name: "printing",
  data() {
    return {
      dialogVisible: false,
      finish: false,
      finishData: { filePageNum: "" },
      search: {
        printState: "",
        sectionId: "",
        subjectId: "",
        versionId: "",
        gradeId: "",
        volumeId: "",
        relationDataId: "",
        volumeId: "",
        chapterId: "",
        resourceTypeId: "",
        fileType: "",
        resourceName: "",
        firstChapterId: "",
        secondChapterId: "",
        thirdChapterId: "",
        fourthChapterId: "",
        page: 1,
        size: 10,
        createUserName: "",
        paperType: "",
        printState: "",
      },
      conditions: {
        xueduanList: [],
        nianjiList: [],
        xuekeList: [],
        banbenList: [],
        ceciList: [],
        zhangjieList1: [],
        zhangjieList2: [],
        zhangjieList3: [],
        zhangjieList4: [],
        ziyuanleibieList: [],
        wendangleixingList: [],
        paperTypeList: [],
      },
      tableData: [],
      pages: {
        pageIndex: 1,
        pageAll: 0,
        pageSize: 10,
      },
      beizhu: {
        id: "",
        remark: "",
      },
      tabH: 0,
    };
  },
  watch: {
    "search.printState": {
      handler(v) {
        this.search.resourceName = "";
        this.getResourcesList();
      },
    },
    "search.sectionId": {
      handler(v) {
        if (v) {
          this.search.gradeId = "";
          this.search.subjectId = "";
          this.search.versionId = "";
          this.search.volumeId = "";
          this.search.chapterId = "";
          this.search.fourthChapterId = "";
          this.search.thirdChapterId = "";
          this.search.secondChapterId = "";
          this.search.firstChapterId = "";
          this.conditions.nianjiList = [];
          this.conditions.xuekeList = [];
          this.conditions.banbenList = [];
          this.conditions.ceciList = [];
          this.conditions.zhangjieList1 = [];
          this.getNianJi();
          this.getXueKe();
        } else {
          this.search.gradeId = "";
          this.search.subjectId = "";
          this.search.versionId = "";
          this.search.volumeId = "";
          this.search.chapterId = "";
          this.search.fourthChapterId = "";
          this.search.thirdChapterId = "";
          this.search.secondChapterId = "";
          this.search.firstChapterId = "";
          this.conditions.nianjiList = [];
          this.conditions.xuekeList = [];
          this.conditions.banbenList = [];
          this.conditions.ceciList = [];
          this.conditions.zhangjieList1 = [];
        }
        this.getResourcesList();
      },
    },
    "search.subjectId": {
      handler(v) {
        if (v) {
          this.search.versionId = "";
          this.search.volumeId = "";
          this.search.chapterId = "";
          this.conditions.banbenList = [];
          this.conditions.ceciList = [];
          this.conditions.zhangjieList1 = [];
          this.getBanben();
        } else {
          this.search.versionId = "";
          this.search.volumeId = "";
          this.search.chapterId = "";
          this.search.fourthChapterId = "";
          this.search.thirdChapterId = "";
          this.search.secondChapterId = "";
          this.search.firstChapterId = "";
          this.conditions.banbenList = [];
          this.conditions.ceciList = [];
          this.conditions.zhangjieList1 = [];
        }
        this.getResourcesList();
      },
    },
    "search.versionId": {
      handler(v) {
        if (v) {
          this.search.volumeId = "";
          this.search.chapterId = "";
          this.conditions.ceciList = [];
          this.conditions.zhangjieList1 = [];
          this.getCeCi();
        } else {
          this.search.volumeId = "";
          this.search.chapterId = "";
          this.search.fourthChapterId = "";
          this.search.thirdChapterId = "";
          this.search.secondChapterId = "";
          this.search.firstChapterId = "";
          this.conditions.ceciList = [];
          this.conditions.zhangjieList1 = [];
        }
        this.getResourcesList();
      },
    },
    "search.volumeId": {
      handler(v) {
        if (v) {
          this.search.relationDataId = v;
          this.search.volumeId = v;
          this.search.chapterId = "";
          this.conditions.zhangjieList1 = [];
          this.getZhangJie();
        } else {
          this.search.relationDataId = "";
          this.search.volumeId = "";
          this.search.chapterId = "";
          this.search.fourthChapterId = "";
          this.search.thirdChapterId = "";
          this.search.secondChapterId = "";
          this.search.firstChapterId = "";
          this.conditions.zhangjieList1 = [];
        }
        this.getResourcesList();
      },
    },
    "search.firstChapterId": {
      handler(v) {
        this.getResourcesList();
      },
    },
  },
  mixins: [downLoad, yulan],
  mounted() {
    this.$nextTick(() => {
      this.tabH = this.$refs.setH.clientHeight - 230;
    });
    this.getXueDuan();
    this.getZiYuanLeiBie();
    this.getWenDangLeixing();
    this.getResourcesList();
    this.getPaperType();
    this.$ajax.post("/common/load/user", {}).then((res) => {
      window.sessionStorage.setItem("clientId", res.clientId);
      window.sessionStorage.setItem("token", res.token);
      window.sessionStorage.setItem("uploadUrl", res.uploadUrl);
      window.sessionStorage.setItem("fileJavaServerUrl", res.fileJavaServerUrl);
      window.sessionStorage.setItem("previewUrl", res.previewUrl);
    });
  },
  methods: {
    getPaperType() {
      this.$ajax.post("/common/load/paper/type").then((res) => {
        this.conditions.paperTypeList = res;
        this.search.paperType = "";
      });
    },
    downloadFun(v) {
      this.$ajax
        .post("/server/record/print/checkUser", { id: v.id })
        .then((res) => {
          if (res) {
            this.downLoad(v, 4);
          } else {
            this.$message({
              message: '送印老师已经不在当前学校"',
              type: "error",
              offset: 20,
              duration: 1000,
            });
          }
        });
    },
    // 获取学段
    getXueDuan() {
      let urlLink = `/common/catalog/load/section`;
      this.$ajax.post(urlLink).then((res) => {
        console.log("获取学段", res);
        this.conditions.xueduanList = res;
      });
    },
    // 获取年级
    getNianJi() {
      let urlLink = `/common/catalog/load/grade`;
      let param = this.search;
      this.$ajax.post(urlLink, param).then((res) => {
        console.log("获取年级", res);
        this.conditions.nianjiList = res;
      });
    },
    // 获取学科
    getXueKe() {
      let urlLink = `/common/catalog/load/subject`;
      let param = this.search;
      this.$ajax.post(urlLink, param).then((res) => {
        console.log("获取学科", res);
        this.conditions.xuekeList = res;
      });
    },
    // 获取版本
    getBanben() {
      let urlLink = `/common/catalog/load/version`;
      let param = this.search;
      this.$ajax.post(urlLink, param).then((res) => {
        console.log("获取版本", res);
        this.conditions.banbenList = res;
      });
    },
    // 获取册次
    getCeCi() {
      let urlLink = `/common/catalog/load/volume`;
      let param = this.search;
      this.$ajax.post(urlLink, param).then((res) => {
        console.log("获取册次", res);
        this.conditions.ceciList = res;
      });
    },
    // 获取章节
    getZhangJie() {
      let urlLink = `/common/catalog/load/chapter`;
      let param = this.search;
      this.$ajax.post(urlLink, param).then((res) => {
        console.log("获取章节", res);
        this.conditions.zhangjieList1 = res;
      });
    },
    // 获取章节2
    selChapter2() {
      this.search.secondChapterId = "";
      this.search.thirdChapterId = "";
      this.search.fourthChapterId = "";
      let urlLink = `/common/catalog/load/chapter`;
      let param = Object.assign({}, this.search, {
        chapterId: this.search.firstChapterId,
      });
      this.$ajax.post(urlLink, param).then((res) => {
        this.conditions.zhangjieList2 = res;
        this.getResourcesList();
      });
    },
    selChapter3() {
      this.search.thirdChapterId = "";
      this.search.fourthChapterId = "";
      let urlLink = `/common/catalog/load/chapter`;
      let param = Object.assign({}, this.search, {
        chapterId: this.search.secondChapterId,
      });
      this.$ajax.post(urlLink, param).then((res) => {
        this.conditions.zhangjieList3 = res;
        this.getResourcesList();
      });
    },
    selChapter4() {
      let urlLink = `/common/catalog/load/chapter`;
      let param = Object.assign({}, this.search, {
        chapterId: this.search.thirdChapterId,
      });
      this.$ajax.post(urlLink, param).then((res) => {
        this.conditions.zhangjieList4 = res;
        this.getResourcesList();
      });
    },
    // 获取资源类别
    getZiYuanLeiBie() {
      let urlLink = `/common/load/resource/type`;
      this.$ajax.post(urlLink).then((res) => {
        console.log("获取资源类别", res);
        this.conditions.ziyuanleibieList = res;
      });
    },
    // 获取文档类型
    getWenDangLeixing() {
      let urlLink = `/common/load/file/type`;
      this.$ajax.post(urlLink).then((res) => {
        console.log("获取文档类型", res);
        this.conditions.wendangleixingList = res;
      });
    },
    handleSizeChange(val) {
      this.search.size = val;
      this.search.page = 1;
      this.getResourcesList();
    },
    // 分页变动
    handleCurrentChange(val) {
      this.search.page = val;
      this.getResourcesList();
    },
    // 加载资源列表
    getResourcesList() {
      let urlLink = `/server/record/print/getRecordPrintList`;
      // let resourceQuery = this.search;
      this.$ajax.post(urlLink, this.search).then((res) => {
        this.tableData = res.list;
        this.pages.pageAll = res.total;
      });
    },
    // 打印完成按钮
    dayinwancheng() {
      if (!this.finishData.printNumber) {
        this.$message({
          message: '请输入纸张数量"',
          type: "error",
          offset: 20,
          duration: 1000,
        });
        return false;
      }
      if (this.finishData.paperType === "") {
        this.$message({
          message: '请选择纸张类型"',
          type: "error",
          offset: 20,
          duration: 1000,
        });
        return false;
      }
      let urlLink = `/server/record/print/updatePrintSuccess`;
      let param = {
        id: this.finishData.id,
        filePage: this.finishData.filePageNum,
        paperType: this.finishData.paperType,
      };
      this.$ajax.post(urlLink, param).then((res) => {
        if (res == "操作成功") {
          this.finish = false;
          this.$message({
            type: "success",
            message: "完成打印!",
            offset: 20,
            duration: 1000,
          });
          this.getResourcesList();
        }
      });
    },
    // 打开备注
    beizhuShow(obg) {
      let urlLink = `/server/record/print/getRecordPrintRemarkById`;
      let param = { id: obg.id };
      this.$ajax.post(urlLink, param).then((res) => {
        console.log("查看是否有备注", res);
        this.beizhu.remark = res ? res : "";
      });
      this.dialogVisible = true;
      this.beizhu.id = obg.id;
    },
    // 保存备注
    baocunbeuzhu() {
      let urlLink = `/server/record/print/updateRemark`;
      let param = this.beizhu;
      this.$ajax.post(urlLink, param).then((res) => {
        console.log("添加备注返回", res);
        if (res == "操作成功") {
          this.$message({
            type: "success",
            message: "备注添加成功!",
            offset: 20,
            duration: 1000,
          });
          this.dialogVisible = false;
          this.getResourcesList();
        }
      });
    },
    // 导出
    daochu() {
      let param = this.search;
      var requestUrl = "/server/record/print/export";

      Axios({
        method: "post",
        url: requestUrl,
        // data: JSON.stringify(param),
        data: qs.stringify(param),
        responseType: "blob",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
        },
      })
        .then((res) => {
          fileDownload(res.data, "文印记录.xlsx");
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/page/printManagement.vue